/**
 * Nicky's Additions - 2025
 * - This section is the additions Nicky from Mondetta has added.
 */
addEventListener("DOMContentLoaded", () => {
  bgImageBlock();
});

function bgImageBlock() {
  // Assigns 'position:relative' to the parent element 
  // Only when set to block relativity vs section (--relativity-block)
  // Remove hidden attribute that was placed to remove flash of misplaced content
  let blocks = document.querySelectorAll('.mci-block-bg-image--relativity-block');
  console.log(blocks);
  if (blocks) {
    blocks.forEach((block) => {
      let blockParent = block.parentElement;
      if (blockParent) {
        blockParent.classList.add('relative');
        block.classList.remove('hidden');
      }
    });
  };
}